'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_CLASSES = exports.USE_CLASSES = exports.SPINNER_SIZE_MAP = exports.ICON_SIZE_MAP = exports.ICON_COLOR_MAP = undefined;

var _colors = require('HubStyleTokens/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ICON_COLOR_MAP = exports.ICON_COLOR_MAP = {
  danger: colors.ALERT_DANGER,
  primary: colors.LORAX,
  secondary: colors.LORAX,
  'secondary-ghost': colors.OLAF,
  tertiary: colors.HEFFALUMP,
  success: colors.OZ,
  link: colors.CALYPSO,
  'on-dark': colors.OLAF
};

var ICON_SIZE_MAP = exports.ICON_SIZE_MAP = {
  large: 32,
  small: 16,
  'extra-small': 10,
  default: 24,
  huge: 48
};

var SPINNER_SIZE_MAP = exports.SPINNER_SIZE_MAP = {
  large: 52,
  small: 28,
  'extra-small': 20,
  default: 40,
  huge: 64
};

var USE_CLASSES = exports.USE_CLASSES = {
  danger: 'private-spinner--destructive',
  primary: 'private-spinner--primary',
  'primary-white': 'private-spinner--primary-white',
  secondary: 'private-spinner--secondary',
  'secondary-ghost': 'private-spinner--secondary-ghost',
  tertiary: 'private-spinner--tertiary',
  success: 'private-spinner--success',
  'tertiary-light': 'private-spinner--tertiary', // same as tertiary
  link: 'private-spinner--link',
  'on-dark': 'private-spinner--on-dark'
};

var SIZE_CLASSES = exports.SIZE_CLASSES = {
  default: 'private-spinner--default',
  large: 'private-spinner--lg',
  huge: 'private-spinner--huge',
  small: 'private-spinner--sm',
  'extra-small': 'private-spinner--xs'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/loading/LoadingConstants.js
// module id = 1113
// module chunks = 2 3